<template>
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               fluid>
    <v-row v-if="tagId">
      <v-col>
        <h1 class="mt-6">Einträge zur Kategorie {{ tagId }}</h1>

        <fin-data-loader :resolver="loadEntries">
          <template #content>
            <fin-academy-grid :posts="academyEntries" class="video-grid"/>
            <div v-intersect="onIntersect"/>
          </template>
        </fin-data-loader>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import FinAcademyGrid from "@/components/pages/finAcademy/grid/AcademyGrid"
import FinDataLoader from "@/components/common/DataLoader"

export default {
  name: "FinAcademyCategory",
  components: {FinAcademyGrid, FinDataLoader},
  props: {
    tagId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tag: undefined,
      academyEntries: [],
      initialNbOfEntriesToLoad: 24
    }
  },
  methods: {
    async loadEntries(afterEntryId = undefined, pageSize = this.initialNbOfEntriesToLoad) {
      const queryCustomType = this.$prismic.Predicates.at('document.type', 'academy_entry')
      const queryTag = this.$prismic.Predicates.at('document.tags', [this.tagId])
      const query = [queryCustomType, queryTag]

      const queryResults = await this.$prismic.client.query(query, {
        orderings: '[my.academy_entry.date desc, document.first_publication_date]',
        after: afterEntryId,
        // TODO accessToken
        pageSize: pageSize
      })
      console.log("queryResults", queryResults)

      // TODO two ways: videos prismic and videos youtube
      const videos = queryResults.results.map((entry, index) => ({
        ...entry.data,
        _meta: {
          uid: entry.uid,
          tags: entry.tags,
        },
        date: entry.data.date !== 0 ? entry.data.date : entry.first_publication_date,
        url: '/academy-entry/' + entry.uid,
        id: entry.id,
        //origEntry: entry
      }))
      this.academyEntries = this.academyEntries.concat(videos)
    },

    onIntersect(entries, observer) {
      if (entries[0].intersectionRatio >= 0.5) {
        this.loadEntries(this.academyEntries[this.academyEntries.length - 1].id, this.nbOfEntriesToLoad)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
